import { FC } from 'react';
import { Doughnut } from 'react-chartjs-2';

import { Box } from '@mui/material';
import { clsx } from 'clsx';

import { IDoughnutChartProps } from './types';

import styles from './DoughnutChart.module.scss';

export const DoughnutChart: FC<IDoughnutChartProps> = ({ className, data }) => {
  return (
    <Box className={clsx(styles.doughnutChart, className)}>
      <Doughnut
        data={{
          labels: data.map(({ title }) => title),
          datasets: [
            {
              data: data.map(({ percentage }) => percentage),
              backgroundColor: data.map(({ color }) => color),
              borderRadius: 8,
              weight: 15,
            },
          ],
        }}
        options={{
          spacing: 6,
          cutout: 55,
          plugins: {
            datalabels: {
              display: false,
            },
            legend: {
              display: false,
            },
            tooltip: {
              enabled: false,
            },
          },
        }}
      />
    </Box>
  );
};
